import { IContextSwitcherData, MUI_PRODUCT_ICONS } from '../types';

export const shouldEnableSubmenu = (contextSwitcherData: IContextSwitcherData) => {
  // Early return if explicitly disabled by the consumer
  if (contextSwitcherData?.disabled) {
    return false;
  }

  // Early return if data is not loaded or still loading
  const hasData = !!contextSwitcherData;
  const isLoading = contextSwitcherData?.loading;

  if (!hasData || isLoading) {
    return false;
  }

  const hasEntitledEntities = contextSwitcherData?.entitledEntities?.length > 0;
  // Force visibility override - always show if explicitly requested and there is data
  const forceContextSwitcherVisibility = contextSwitcherData?.forceContextSwitcherVisibility;
  if (forceContextSwitcherVisibility && hasEntitledEntities) {
    return true;
  }

  // Get entity and application counts
  const entitledEntitiesCount = contextSwitcherData?.entitledEntities?.length || 0;
  const entitledApplicationsCount = contextSwitcherData?.activeEntity?.entitledApplications?.length || 0;
  // Check if current app is admin settings
  const isAdminApp = contextSwitcherData?.activeEntity?.entitledApplications?.some(
    (app) => app.entitlementProductKey === MUI_PRODUCT_ICONS.adminsettings
  );

  const hasForcedDefaultApplication = contextSwitcherData?.forcedDefaultApplication;

  // Show submenu in these scenarios:
  // 1. Multiple entities (user can switch between entities)
  const hasMultipleEntities = entitledEntitiesCount > 1;
  if (hasMultipleEntities) {
    return true;
  }

  // 2. Single entity with multiple applications (user can switch between apps)
  const hasOnlyOneEntity = entitledEntitiesCount === 1;
  const hasMultipleApplications = entitledApplicationsCount > 1;
  if (hasOnlyOneEntity && hasMultipleApplications && !hasForcedDefaultApplication) {
    return true;
  }

  // 3. Single entity, single application, but it's admin settings
  if (hasOnlyOneEntity && !hasMultipleApplications && isAdminApp && !hasForcedDefaultApplication) {
    return true;
  }

  // No conditions met - don't show submenu
  return false;
};
